import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import {
  KeyboardArrowDown,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import queryStringParse from "../../../../../../functions/queryParam";
const TicketModalDetails = (props) => {
  const history = useHistory();

  const [scroll, setScroll] = React.useState("body");

  const handleClose = () => {
    let copy = props.open;
    copy[props.ticketId] = false;
    props.setOpen(copy);
  };

  const persianDateHandler = () => {
    let urlDate =null;
    let params=[];
    if (history.location.search ) {
      var search = history.location.search;
       params = queryStringParse(search);
   
   }

   if (params.date && params.date!=null) {
     urlDate = params.date;
   }else{
    urlDate = history.location.pathname.split("/")[4].split("-");
   }
 
    let dateOptions = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const persianDate = new Date(urlDate).toLocaleDateString(
      "fa-Ir",
      dateOptions
    );

    const day = persianDate.split(",")[1];
    const monthAnddate = persianDate.split(",")[0].split(" ");

    const mixed = `${day}, ${monthAnddate[2]} ${monthAnddate[1]}`;

    return mixed;
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [props.open]);

  return (
    <>
      <Dialog
        style={{ whiteSpace: "nowrap" }}
        PaperProps={{
          style: {
            height: "60%",
          },
        }}
        className="mx-auto"
        fullWidth
        open={props.open[props.ticketId]}
        onClose={handleClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogContent dividers={scroll === "paper"}>
          <div className="w-100" style={{ width: "100%" }}>
            <div className="d-flex justify-content-between p-3">
              <h4 className="text-center" style={{ fontSize: "18px" }}>
                <b>{persianDateHandler()}</b>
              </h4>
              <i className="fa fa-times" onClick={() => handleClose()}></i>
            </div>
            <div
              className="line w-100 mx-auto"
              style={{ borderBottom: "2px solid black" }}
            ></div>
            <div className="row my-5">
              <div className="col-sm-6 d-flex p-3">
                <div className="d-flex" style={{ gap: 10 }}>
                  <div className="d-flex flex-column justify-content-between">
                    <h4>
                      <b>{props.departureDatetime}</b>
                    </h4>
                    <h4>
                      <b>{props.arrivedTime}</b>
                    </h4>
                  </div>
                  <div>
                    <i className="fa fa-circle" style={{ color: "gray" }}>
                      <div
                        className="connect-line"
                        style={{ marginRight: 6.5, height: "5rem" }}
                      ></div>
                      <i
                        className="fa fa-circle"
                        style={{ color: "black" }}
                      ></i>
                    </i>
                  </div>
                  <div className="d-flex flex-column justify-content-between">
                    <h4>{props.directionSourceTitle}</h4>
                    <h6 style={{ color: "#cca435" }}>
                      <span>ایستگاه ۲</span>
                      <KeyboardArrowDown />
                    </h6>
                    <h4>{props.directionDestTitle}</h4>
                  </div>
                </div>
                <div
                  className="col-sm-6 d-flex flex-column"
                  style={{ alignItems: "baseline", justifyContent: "flex-end" }}
                >
                  {/* <div
                    className="d-flex flex-column  dg1-border p-2 w-auto h-auto"
                    style={{
                      gap: 10,
                      borderRadius: "20px",
                      marginRight: "auto",
                    }}
                  >
                    <img
                      src={toAbsoluteUrl("/media/ebusCardLogos/Group 62.png")}
                    />
                    <img
                      src={toAbsoluteUrl("/media/ebusCardLogos/Group 63.png")}
                    />
                    <img
                      src={toAbsoluteUrl("/media/ebusCardLogos/Group 64.png")}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <div
          className="line w-100 mx-auto my-1 d-none d-lg-block col-lg-3 bg-white rounded"
          style={{ borderBottom: "2px solid black" }}
        ></div>
        <DialogActions className="d-flex">
          <div className="col-sm-6">
            <Button
              className="btn w-100 col-12 p-3 align-items-center"
              style={{
                backgroundColor: "#6dd06d",
                whiteSpace: "nowrap",
                borderRadius: "12px",
              }}
            >
              <h5 className="my-auto text-white" style={{ opacity: "0.85" }}>
                <b>انتخاب صندلی</b>
              </h5>
            </Button>
          </div>
          <div className="col-sm-6">
            <h2 className="text-dark mx-auto">
              <span style={{ opacity: "0.85" }}>
                <b>{props.basePrice}</b>
              </span>
              <span style={{ opacity: 0.5 }}>تومان</span>
            </h2>
            <span className="mx-auto my-2" style={{ opacity: 0.5 }}>
              ظرفیت موجود:{props.emptySeatCount}
            </span>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TicketModalDetails;
